export default "__VITE_ASSET__Dvs74P5w__"